// The call banner (spec-v4 section 8.4): while a call is on and the stage is tucked away, one slim row says who's on
// the call and what's on stage, with "Back to stage". Phones: on top of the Director bar, above the tabs (the same
// slot). Desktop: the top of the rail column. It pulses when the Director showed something while the user was busy.
import { DirectorMark, useShownStatus } from "../components/Director";
import { usePersona } from "../components/DirectorPicker";
import { useStore } from "../store";
import { backToStage } from "./actions";
import { stageDoing } from "./state";

/** Is there a banner to show? (a live call with a minimised stage) */
export const useBannerUp = () => useStore((s) => s.stage.open && s.stage.minimised && s.director !== "off" && s.director !== "error");

export function CallBanner({ variant = "bar", label = "Back to stage" }: { variant?: "bar" | "rail" | "panel"; label?: string }) {
  const up = useBannerUp();
  const stage = useStore((s) => s.stage);
  const status = useShownStatus();
  const persona = usePersona();
  if (!up) return null;
  const line = stage.attention ?? stageDoing(stage);
  return (
    <div className={`cbanner cbanner-${variant}${stage.attention ? " is-pulse" : ""}`} role="status" aria-live="polite">
      <span className="cbanner-mark" aria-hidden>
        <DirectorMark status={status} />
      </span>
      <p className="cbanner-text">
        <strong>{persona.name}</strong>
        <span className="cbanner-sep" aria-hidden>
          {" · "}
        </span>
        <span className="cbanner-line">{line}</span>
      </p>
      <button data-action="stage.minimise" type="button" className="btn btn-primary btn-small cbanner-back" onClick={backToStage}>
        {label}
      </button>
    </div>
  );
}
